export default "__VITE_ASSET__B7uMhh49__"